// frontend/src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Menu from './pages/Menu';
import Cart from './pages/Cart';
import Complaint from './pages/Complaint';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import BranchPage from './pages/branch/BranchPage';
import './App.css';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : false;
  });

  const [user, setUser] = useState(() => {
    const saved = sessionStorage.getItem('moyobed_user') || localStorage.getItem('moyobed_user');
    return saved ? JSON.parse(saved) : null;
  });

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    if (darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [darkMode]);

  const toggleTheme = () => setDarkMode(!darkMode);

  return (
    <Router>
      <div className={`app ${darkMode ? 'dark' : ''}`}>
        <div className="parallax-bg"></div>
        
        <Routes>
          <Route path="/" element={
            user ? (user.is_admin ? <Navigate to="/admin" /> : <Navigate to="/menu" />) : 
            <Login setUser={setUser} />
          } />
          <Route path="/menu" element={
            user ? <Menu user={user} darkMode={darkMode} toggleTheme={toggleTheme} /> : <Navigate to="/" />
          } />
          <Route path="/cart" element={
            user ? <Cart user={user} darkMode={darkMode} toggleTheme={toggleTheme} /> : <Navigate to="/" />
          } />
          <Route path="/profile" element={user ? <Profile user={user} darkMode={darkMode} toggleTheme={toggleTheme} /> : <Navigate to="/" />} />
          <Route path="/complaint" element={
            user ? <Complaint user={user} darkMode={darkMode} toggleTheme={toggleTheme} /> : <Navigate to="/" />
          } />
          <Route path="/admin" element={
            user?.is_admin ? <Admin user={user} darkMode={darkMode} toggleTheme={toggleTheme} /> : <Navigate to="/" />
          } />
          <Route path="/branch/:branchId" element={
            user ? <BranchPage key={window.location.pathname} user={user} /> : <Navigate to="/" />
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
